// extracted by mini-css-extract-plugin
module.exports = {"header":"Simple_header__3ykwh","logo":"Simple_logo__1RiPO","container":"Simple_container__37Em-"};